import { useIsCustomerMode } from '@plato/app-core/hooks/use-customer-mode';
import type { PropsWithChildren, ReactNode } from 'react';

type MaskedContentProps = {
    mask?: ReactNode;
} & PropsWithChildren;

export function MaskedContent({ children, mask = '*****' }: MaskedContentProps) {
    const customerViewToggled = useIsCustomerMode();

    return <>{customerViewToggled ? mask : children}</>;
}
